import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/assets/images/more-grass-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-3400b3b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"max-width":"1000px","margin-left":"auto","margin-right":"auto"} }
const _hoisted_2 = { style: {"position":"relative","width":"100%","min-height":"200px"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "main-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"55px"} }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sound-explanation-grass",
  src: _imports_0,
  alt: ""
}, null, -1))

import { computed, onMounted, ref } from "vue";
import { IonCol, IonContent, IonGrid, IonLabel, IonPage, IonRow } from "@ionic/vue";
import router from "@/router";
import CustomHeader from "@/components/CustomHeader.vue";
import CustomFooter from "@/components/CustomFooter.vue";
import DetailsOverlay from "@/views/DetailsOverlay.vue";
import AudioPlayerComp from "@/components/AudioPlayerComp.vue";
import ImageCarousel from "@/components/ImageCarousel.vue";
import { useStore } from "@/stores/main";
import { storeToRefs } from "pinia";
import InfoEntry from "@/views/InfoEntry.vue";
import { getImageUrl } from "@/utils/FileUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'EntryDetails',
  setup(__props) {

const entryId = router.currentRoute.value.params.id as string
const audioId = ref(0)

const store = useStore()

const { contentDetails, font } = storeToRefs(store)

const changedAudio = (title: number) => {
    audioId.value = title
}

const contentInfo = computed(() => {
    return contentDetails.value?.[entryId]
})

onMounted(() => store.loadContentDetails(entryId))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: "" }, {
        default: _withCtx(() => [
          (_unref(contentInfo))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(CustomHeader, { "has-back-button": "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("img", {
                          class: "header-image",
                          src: _unref(getImageUrl)(_unref(contentInfo).mainImage),
                          alt: "",
                          id: "trigger-button"
                        }, null, 8, _hoisted_3)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonGrid), { class: "text-field" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(contentInfo).title), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentInfo).profile, (info) => {
                        return (_openBlock(), _createBlock(InfoEntry, {
                          key: info.id,
                          "font-size-title": _unref(font).fontSizeTitle,
                          "font-size": _unref(font).fontSize,
                          text: info.text,
                          title: info.title,
                          "text-color-blue": false
                        }, null, 8, ["font-size-title", "font-size", "text", "title"]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(ImageCarousel, {
                    class: "image-carousel",
                    images: _unref(contentInfo).images
                  }, null, 8, ["images"]),
                  _createVNode(AudioPlayerComp, {
                    "audio-list": _unref(contentInfo).audioFiles,
                    onChangedAudio: changedAudio
                  }, null, 8, ["audio-list"]),
                  (_unref(contentInfo).audioFiles.length > 0)
                    ? (_openBlock(), _createBlock(_unref(IonGrid), {
                        key: 0,
                        class: "sound-explanation-text-container"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonRow), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), {
                                    class: _normalizeClass([_ctx.fontSize, "info-titles"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(contentInfo).audioFiles[audioId.value].title), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["class"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonRow), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonCol), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(contentInfo).audioFiles[audioId.value].description), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_5,
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(IonGrid), { class: "special-information-container" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contentInfo).additionalInfo, (info) => {
                        return (_openBlock(), _createBlock(InfoEntry, {
                          key: info.id,
                          "font-size-title": _unref(font).fontSizeTitle,
                          "font-size": _unref(font).fontSize,
                          text: info.text,
                          title: info.title,
                          textColorBlue: true
                        }, null, 8, ["font-size-title", "font-size", "text", "title"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(CustomFooter, { class: "footer" }),
                _createVNode(DetailsOverlay, {
                  "font-size-title": _unref(font).fontSizeTitle,
                  tags: _unref(contentInfo).detailMarkers,
                  "image-url": _unref(getImageUrl)(_unref(contentInfo).mainImage)
                }, null, 8, ["font-size-title", "tags", "image-url"])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})